const RELATED_TYPES = ["supplementary", "reconciliation"];

export const claimBatchContext = (cluster) => {
  const ref = String(cluster?.ref || "a").toLowerCase();
  const type = String(cluster?.type || "original").toLowerCase();

  if (ref === "a" && type === "original") {
    return null;
  }

  if (!RELATED_TYPES.includes(type)) {
    return null;
  }

  return {
    key: type,
    label: `${type.charAt(0).toUpperCase()}${type.slice(1)} ${ref.toUpperCase()}`,
  };
};
